export default "__VITE_ASSET__d4VQ8YnH__"